/* ============================================================
   CTR Bundle PDP B4
   Drives the three-card bundle selector + "Gifts unlocked" card.

   It does NOT add to cart itself — it keeps the existing
   ctr-main-product-v2 ATC flow in sync by writing into the data
   that flow already reads on submit:
     • the ATC form's hidden `quantity` input  → selected tier qty
     • the section's data-...-free-variant-ids  → unlocked gift variants
   The shared ctr-main-product-v2.js then adds the main product
   (with that quantity) plus each gift variant, and redirects to
   /checkout. Discounts are applied on the backend.
   ============================================================ */

(function () {
  'use strict';

  function initB4(section) {
    if (!section || section.__ctrB4Init) return;
    var bundles = section.querySelector('[data-ctr-b4-bundles]');
    if (!bundles) return;
    section.__ctrB4Init = true;

    var cards = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-b4-card]')
    );
    var gifts = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-b4-gift]')
    );
    var forms = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-main-product-v2-form]')
    );
    if (!cards.length) return;

    /* ── Capture stable divider→gift associations from initial DOM ── */
    var giftsList = section.querySelector('.ctr-main-product-v2__gifts-list');
    var giftGroups = [];
    if (giftsList) {
      var pendingDivider = null;
      Array.prototype.slice.call(giftsList.children).forEach(function (el) {
        if (el.classList.contains('ctr-main-product-v2__gifts-divider')) {
          pendingDivider = el;
        } else if (el.hasAttribute('data-ctr-b4-gift')) {
          giftGroups.push({ divider: pendingDivider, gift: el });
          pendingDivider = null;
        }
      });
    }

    function reorderGifts() {
      if (!giftsList || !giftGroups.length) return;
      var unlocked = giftGroups.filter(function (g) { return g.gift.classList.contains('is-unlocked'); });
      var locked   = giftGroups.filter(function (g) { return g.gift.classList.contains('is-locked'); });

      /* detach all gift rows and their dividers */
      giftGroups.forEach(function (g) {
        if (g.divider && g.divider.parentNode) g.divider.parentNode.removeChild(g.divider);
        if (g.gift.parentNode) g.gift.parentNode.removeChild(g.gift);
      });

      /* re-append: unlocked (no dividers) then locked (with dividers) */
      unlocked.forEach(function (g) { giftsList.appendChild(g.gift); });
      locked.forEach(function (g) {
        if (g.divider) giftsList.appendChild(g.divider);
        giftsList.appendChild(g.gift);
      });
    }

    function getSelectedCard() {
      var checked = section.querySelector('[data-ctr-b4-card] input[type="radio"]:checked');
      if (checked) {
        var card = checked.closest('[data-ctr-b4-card]');
        if (card) return card;
      }
      return cards[0];
    }

    function apply() {
      var card = getSelectedCard();
      var tier = parseInt(card.getAttribute('data-tier'), 10) || 1;
      var qty = parseInt(card.getAttribute('data-quantity'), 10) || 1;

      /* selected-card styling + radio state */
      cards.forEach(function (c) {
        var isOn = c === card;
        c.classList.toggle('is-selected', isOn);
        var radio = c.querySelector('input[type="radio"]');
        if (radio) radio.checked = isOn;
      });

      /* lock / unlock gifts and collect unlocked variant ids */
      var ids = [];
      gifts.forEach(function (g) {
        var giftTier = parseInt(g.getAttribute('data-gift-tier'), 10) || 1;
        var unlocked = giftTier <= tier;
        g.classList.toggle('is-unlocked', unlocked);
        g.classList.toggle('is-locked', !unlocked);
        if (unlocked) {
          var vid = g.getAttribute('data-gift-variant-id');
          if (vid && ids.indexOf(vid) === -1) ids.push(vid);
        }
      });

      /* point every form at the selected tier's variant (qty 1). The one-time form gets
         the same variant but NO selling plan, so "Try it Once" buys that tier's variant
         (1 / 3 / 5 month supply) as a one-time purchase at the variant's own price. */
      var selectedVariantId   = card.getAttribute('data-variant-id');
      var selectedSellingPlan = card.getAttribute('data-selling-plan-id');
      forms.forEach(function (f) {
        var variantInput = f.querySelector('input[name="id"]');
        if (variantInput && selectedVariantId) variantInput.value = selectedVariantId;
        var qtyInput = f.querySelector('input[name="quantity"]');
        if (qtyInput) qtyInput.value = 1;
        if (f.classList.contains('ctr-main-product-v2__one-time')) return; /* one-time: no selling plan */
        var planInput = f.querySelector('[data-ctr-main-product-v2-selling-plan]');
        if (planInput && selectedSellingPlan) planInput.value = selectedSellingPlan;
      });

      /* update the "Try it Once" price to the selected tier variant's one-time price */
      var oneTimePrice = card.getAttribute('data-onetime-price');
      if (oneTimePrice) {
        var otValEl = section.querySelector('[data-ctr-main-product-v2-onetime-price-val]');
        if (otValEl) otValEl.textContent = oneTimePrice;
        section.querySelectorAll('[data-ctr-main-product-v2-one-time-price]').forEach(function (el) {
          var template = el.dataset.ctrMainProductV2OneTimePrice;
          if (template) el.textContent = template.replace('[price]', oneTimePrice);
        });
      }

      /* hand the unlocked gift variants to the shared cart flow */
      section.dataset.ctrMainProductV2FreeVariantIds = ids.join(',');

      /* reorder gift rows so unlocked float above the divider */
      reorderGifts();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        apply();
      });
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change', apply);
    });

    apply();
  }

  function boot() {
    document
      .querySelectorAll('[data-ctr-main-product-v2-section]')
      .forEach(initB4);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-init when the section reloads */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-ctr-main-product-v2-section]');
    if (section) {
      section.__ctrB4Init = false;
      initB4(section);
    }
  });

  /* Theme editor: selecting a Bundle (B4) block highlights its card */
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest('[data-ctr-b4-card]');
    if (!card) return;
    var radio = card.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
